import styled from "styled-components";

export const StyledShoppingCartContainer = styled.div`
    max-width: ${props => props.theme.container.maxWidth};
    padding: ${props => props.theme.container.padding};
    height: inherit;
    margin: 0 auto;
`
export const ShoppingCartContent = styled.div`
    overflow-y: auto;
    height: inherit;
    padding-bottom: 100px;
    padding-right: 5px;
    margin-right: -5px;

`
export const StyledShoppingGoToBack = styled.div`
    margin-bottom: 24px;

    button {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 16px;
        background-color: transparent;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        font-family: ${props => props.theme.fonts.monserrat};
        color: ${props => props.theme.colors.darkBlue};
    }
`

export const StyledListCartItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const StyledSection = styled.div`
    margin: 24px 0;

`